textOnHover.$inject = ['$'];

export function textOnHover($) {
    return {
        scope: {
            textOnHover: '@textOnHover'
        },
        link: function ($scope, element) {
            let backupText = '';
            $(element).on('mouseover', () => {
                backupText = $(element).text();
                $(element).text($scope.textOnHover);
            });

            $(element).on('mouseout', () => {
                $(element).text(backupText);
            });
        }
    };
}



// WEBPACK FOOTER //
// ./src/modules/shared/directives/TextOnHoverDirective.js